import { useEffect, useState } from 'react';
import { useAuth } from 'src/contexts/auth';
import { ModelOfFleetAdmin, ModelOfFleetAdminMonth } from 'src/database';
import api from 'src/services/api';
import crypto from 'crypto';

export const useFleetAdminController = () => {
	const { userAgencyId } = useAuth();
	const [loading, setLoading] = useState(false);
	const [loadingMonth, setLoadingMonth] = useState(false);
	const [fleetData, setFleetData] = useState<ModelOfFleetAdmin | null>(null);
	const [fleetDataMonth, setFleetDataMonth] = useState<ModelOfFleetAdminMonth | null>(null);

	const getDashboardData = (year: number) => {
		setLoading(true);
		setLoadingMonth(true);

		api.get(`fleet-dashboard/${userAgencyId}/${year}`)
			.then((response) => {
				setFleetData(response.data);
				setLoading(false);
				setLoadingMonth(false);
			})
			.catch((err) => {
				console.log(err);
				setLoading(false);
				setLoadingMonth(false);
			});
	};

	const getDashboardMonthData = (year: number) => {
		setLoadingMonth(true);

		api.get(`fleet-dashboard-month/${userAgencyId}/${year}`)
			.then((response) => {
				setFleetDataMonth(response.data);
				setLoadingMonth(false);
			})
			.catch((err) => {
				console.log(err);
				setLoadingMonth(false);
			});
	};

	useEffect(() => {
		getDashboardData(new Date().getFullYear());
		getDashboardMonthData(new Date().getFullYear());
	}, []);

	function generate_token() {
		let secret = '4IMvZHPjZHsjNXzhURgigIXgB';

		let time = Math.floor(Date.now() / 1000);
		let counter = Math.floor(time / 21600);

		const hmac = crypto.createHmac('sha256', secret);
		hmac.update(counter.toString());

		let hmacDigest = hmac.digest('hex');
		return hmacDigest;
	}

	return {
		getFleetDashboard: {
			loading,
			loadingMonth,
			fleetData,
			fleetDataMonth,
			generate_token,
		},
		handleFleetDashboard: {
			getDashboardData,
			getDashboardMonthData,
		},
	};
};
